import { SelectorOption } from 'src/app/interfaces/form-and-field.interface';
import { SearchCategories } from './search.enum';

export const defaultSearchOption: SelectorOption = {
  entity_id: SearchCategories.ALL_CATEGORIES,
  title: 'SEARCH_FIELDS_BY_CATEGORIES',
};

export const unauthenticatedSearchOptions: SelectorOption[] = [
  defaultSearchOption,
  {
    entity_id: SearchCategories.COMMUNITIES,
    title: 'SEARCH_FIELDS_BY_COMMUNITIES',
  },
  {
    entity_id: SearchCategories.PROJECTS,
    title: 'SEARCH_FIELDS_BY_PROJECTS',
  },
  { entity_id: SearchCategories.POSTS, title: 'SEARCH_FIELDS_BY_POSTS' },
];

export const authenticatedSearchOptions: SelectorOption[] = [
  ...unauthenticatedSearchOptions,
  {
    entity_id: SearchCategories.ORGANIZATIONS,
    title: 'SEARCH_FIELDS_BY_ORGANIZATIONS',
  },
  {
    entity_id: SearchCategories.PATIENTS,
    title: 'SEARCH_FIELDS_BY_PATIENTS',
  },
  {
    entity_id: SearchCategories.DOCTORS,
    title: 'SEARCH_FIELDS_BY_DOCTORS',
  },
  { entity_id: SearchCategories.USERS, title: 'SEARCH_FIELDS_BY_USERS' },
  { entity_id: SearchCategories.COMMENTS, title: 'SEARCH_FIELDS_BY_COMMENTS' },
];

export const socialGroupSearchOptions: SelectorOption[] = [
  {
    entity_id: SearchCategories.USERS,
    title: 'SEARCH_FIELDS_BY_CATEGORIES',
  },
  {
    entity_id: SearchCategories.ORGANIZATIONS,
    title: 'SEARCH_FIELDS_BY_ORGANIZATIONS',
  },
  {
    entity_id: SearchCategories.PATIENTS,
    title: 'SEARCH_FIELDS_BY_PATIENTS',
  },
  {
    entity_id: SearchCategories.DOCTORS,
    title: 'SEARCH_FIELDS_BY_DOCTORS',
  },
  {
    entity_id: SearchCategories.RESEARCHERS,
    title: 'SEARCH_FIELDS_BY_RESEARCHERS',
  },
  {
    entity_id: SearchCategories.MED_STAFF,
    title: 'SEARCH_FIELDS_BY_MED_STAFF',
  },
];
